export default "__VITE_ASSET__DOWa9LWy__"